<template>
    <div class="wrapper-ficha noticia">

        <!-- <a @click="back" class="volver"><img src="/img/flecha_salir-azul.svg" alt=""></a> -->


        <div class="contenedor-evento" v-if="data">
            <h1 class="title-evento">Incripción a evento: <br>
                <span class="title-evento-span">{{ data.title }}</span>
            </h1>
            <template v-if="logged && !popup">
                <button @click="openPopup" class="boton-azul -popup"
                    v-if="data.open == 1 && data.status == 0 && !fechaactual && data.type == 0">Inscribirse </button>
                <template v-else>
                    <a v-if="data.open == 1 && data.status == 0 && !fechaactual" @click="inscripcion" class="boton-azul"
                        :loading="loading">Inscribirse</a>
                </template>
            </template>

            <template v-if="logged">
                <p v-if="data.open == 1 && data.status == 1 && !fechapasada">Tu inscripción se ha realizado
                    correctamente.
                    Cualquier consulta puedes escribirnos a <a href="mailto:alumni@ufv.es">alumni@ufv.es</a>.</p>
                <a v-if="data.open == 1 && data.status == 1 && !fechapasada" @click="cancelar" class="boton-gris"
                    :loading="loading">Cancelar inscripción</a>
                <p v-if="data.status == 2"><strong>La inscripción ha sido cancelada</strong>. Cualquier consulta puedes
                    escribirnos a <a href="mailto:alumni@ufv.es">alumni@ufv.es</a>.</p>
            </template>

            <template v-else>
                <router-link v-if="data.open == 1 && !fechaactual" :to="`/login?callback=${$route.fullPath}`"
                    class="boton-azul">Inscribirse</router-link>
            </template>
            <!-- 
            <div class="imagen-principal">
                <img :src="data.image.url" :alt="data.title">
            </div> -->



            <!-- 
            <div class="contenedor-cuerpo">

                <div class="cuerpo-real">

                    <h2>{{data.title}}</h2>
                    <p>{{data.category.name}}</p>
                    <h4 class="js-fecha">{{data.date | date}}</h4>

                    <p><strong>Organizador:</strong> {{data.organizer}}</p>
                    <p><strong>Precio:</strong> {{data.price}}</p>
                    <p><strong>Horario:</strong> {{data.schedule}}</p>
                    <p><strong>Dirección:</strong> {{data.address}}</p>

                    <editorjs :modulos="data.description"></editorjs>
                   


                </div>

            </div> -->
        </div>
        <section class="popup-mask" v-if="popup">
            <div class="container-mask">
                <router-link class="close"
                    :to="`/login?callback=/es/comunidad/eventos/${$route.params.id}`">✕</router-link>
                <div class="contenedor-input popup-asistencia">
                    <p class="title">Por favor selecciona el tipo de asistencia para inscribirte a este evento:</p>
                    <ValidationProvider ref="dataTypeProvider" rules="required" v-slot="{ errors, ariaMsg }">
                        <span>
                            <div class="contenedor-input row-start fww contenedor-asistencia">
                                <input type="radio" value="1" name="attendance_type" id="presencialidad" v-model="data_type"
                                    @change="onDataTypeChange">
                                <label for="presencialidad">Presencial</label>
                                <input type="radio" value="2" name="attendance_type" id="online" v-model="data_type"
                                    @change="onDataTypeChange">
                                <label for="online">Online</label>
                            </div>
                        </span>
                        <small v-bind="ariaMsg" v-if="errors[0] || dataTypeError" class="custom-error evento-ficha-type-error">
                            {{ errors[0] || dataTypeError }}
                        </small>
                    </ValidationProvider>
                    <div class="container-text-legal">
                        <p><strong>Información básica sobre protección de datos personales </strong></p>
                        <p><strong>Responsable del tratamiento</strong>: Fundación Universidad Francisco de Vitoria
                            (UFV). Los
                            datos de contacto de la UFV son los siguientes: </p>
                        <ul>
                            <li>Dirección postal: Ctra. M-515 Pozuelo-Majadahonda Km. 1.800, 28223 Pozuelo de Alarcón,
                                Madrid.
                                Dirección electrónica: secretariageneral@ufv.es </li>

                            <li>Teléfono: <a href="tel:+91 709 14 00">+34 91 709 14 00</a> </li>

                            <li>Las Personas Interesadas pueden contactar con la Oficina del Delegado de Protección de
                                Datos de
                                la
                                UFV en la dirección electrónica: <a href="mailto:dpd@ufv.es.">dpd@ufv.es.</a> </li>
                        </ul>
                        <p><strong>Legitimación y finalidades del tratamiento:</strong> con base jurídica en el
                            consentimiento
                            otorgado por la
                            Persona Participante mediante la marcación de la correspondiente casilla destinada al
                            efecto, sus
                            datos personales serán tratados con la finalidad de gestionar su participación en {{
                            data.title }}.
                        </p>
                        <p>
                            <strong>Destinatarios:</strong> sus datos personales no serán comunicados a terceras
                            personas. No
                            obstante, con base jurídica en el cumplimiento de obligaciones legales, sus datos personales
                            podrán
                            ser comunicados a autoridades administrativas y órganos judiciales con competencia en la
                            materia
                            cuando así se establezca en la normativa aplicable. Igualmente, terceros encargados del
                            tratamiento
                            podrán tener acceso a los Datos Personales para la prestación de servicios, al amparo y
                            previa
                            suscripción de un contrato de encargo de tratamiento y confidencialidad de la información.
                        </p>
                        <p><strong>Derechos:</strong> acceso, rectificación, supresión, limitación, oposición,
                            portabilidad, a
                            retirar el consentimiento sin que ello afecte a la licitud del tratamiento basado en el
                            consentimiento
                            previo a su retirada, a no ser objeto de una decisión basada únicamente en el tratamiento
                            automatizado, incluida la elaboración de perfiles y a presentar una reclamación ante una
                            autoridad
                            de
                            control. </p>
                        <p><strong>Información adicional sobre protección de datos: </strong><a
                                href="https://www.ufv.es/politica-de-privacidad-eventosufv/" target="_blank"
                                rel="noopener noreferrer">https://www.ufv.es/politica-de-privacidad-eventosufv/</a> </p>

                    </div>
                    <div class="contenedor-input">
                        <ValidationProvider ref="privacyProvider" rules="required" v-slot="{ errors, ariaMsg, classes }">
                            <input type="checkbox" id="contact" name="privacy_check" v-model="privacy_check" :class="classes"
                                @change="onPrivacyChange" />
                            <label for="contact">Acepto y autorizo a que mis datos sean tratados por la
                                Universidad Francisco de Vitoria, con las finalidades
                                indicadas anteriormente y para remitirme, por cualquier medio,
                                incluidos los electrónicos (SMS, Whatsapp, correo electrónico
                                y redes sociales) las comunicaciones correspondientes.*</label>
                            <span v-bind="ariaMsg" v-if="errors[0] || privacyError" class="custom-error evento-ficha-type-error">{{
                                errors[0] || privacyError
                            }}</span>
                        </ValidationProvider>
                    </div>
                </div>
                <a v-if="data.open == 1 && data.status == 0 && !fechaactual" @click="inscripcion" class="boton-azul"
                    :loading="loading">Inscribirse</a>
            </div>
        </section>

    </div>
</template>


<script>

import { mapActions, mapGetters } from 'vuex';
import router from '@/router';

export default {
    name: 'evento',
    mounted() {
        this.setData();
    },
    data: () => ({
        data: '',
        data_type: null,
        dataTypeError: '',
        privacyError: '',
        loading: false,
        popup: false,
        privacy_check: false
    }),
    methods: {
        ...mapActions(['requestEvento', 'requestInscripcion', 'requestCancelInscripcion']),
        setData() {
            this.requestEvento(this.$route.params.id).then(r => {
                if (r) {
                    this.data = r;
                    this.data_type = this.data.type && this.data.type != 0 ? String(this.data.type) : null;
                    this.dataTypeError = '';
                    this.privacyError = '';
                    this.privacy_check = false;
                    if (this.logged && this.data.open == 1 && this.data.status == 0) {
                        this.popup = true;
                    }
                }
                else {
                    router.push({ name: 'login' });
                    return;
                }

            })


        },
        openPopup() {
            this.popup = true
        },
        closePopup() {
            this.popup = false
        },
        back() {
            router.go(-1)
        },
        onDataTypeChange() {
            this.dataTypeError = '';
            if (this.$refs.dataTypeProvider) {
                this.$refs.dataTypeProvider.validate();
            }
        },
        onPrivacyChange() {
            this.privacyError = '';
            if (this.$refs.privacyProvider) {
                this.$refs.privacyProvider.validate();
            }
        },
        inscripcion() {
            if (!this.data_type) {
                this.dataTypeError = 'Este campo es obligatorio';
                if (this.$refs.dataTypeProvider) {
                    this.$refs.dataTypeProvider.validate();
                }
                return;
            }

            this.dataTypeError = '';
            this.privacyError = '';

            if (!this.privacy_check) {
                this.privacyError = 'Este campo es obligatorio';
                if (this.$refs.privacyProvider) {
                    this.$refs.privacyProvider.validate();
                }
                return;
            }

            this.loading = true;
            this.requestInscripcion({ id: this.data.id, type: this.data_type }).then(() => {
                this.loading = false;
                this.setData();
                this.popup = false
            });
        },
        cancelar() {
            this.loading = true;
            this.requestCancelInscripcion(this.data.id).then(() => {
                this.loading = false;
                this.setData();
            });
        }
    },
    computed: {
        ...mapGetters({
            logged: 'getLogged'
        }),
        fechapasada() {

            if (this.data.limit_cancel_date) {

                let pasada = new Date(this.data.limit_cancel_date).getTime();
                let actual = new Date().getTime();

                return (actual > pasada)
            } else {
                return false;
            }
        },
        fechaactual() {
            let pasada = new Date(this.data.date).getTime();
            let actual = new Date().getTime();

            return (actual > pasada)
        }
    },
    watch: {
        '$route'() {
            this.setData();
        }
    }
}
</script>